// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import { loadProgressBar } from 'axios-progress-bar'
import Vuelidate from 'vuelidate'
import App from './App'
import router from './router'
import { Events } from './events'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options)
Vue.use(Vuelidate)
Vue.use(loadProgressBar)
Vue.use(BootstrapVue)

axios.defaults.withCredentials = true

Vue.prototype.$http = axios
Vue.prototype.API_ENDPOINT = (process.env.NODE_ENV !== 'production') ? process.env.API_ENDPOINT : 'api-labs'
Vue.prototype.CURRENCY = (process.env.NODE_ENV !== 'production') ? process.env.CURRENCY : 'INR'

Vue.prototype.SETTING = {
  product: process.env.PRODUCT,
  productLink: process.env.PRODUCTLINK,
  system: process.env.SYSTEM,
  logo: process.env.LOGO,
  timezone: process.env.TIMEZONE
}

router.beforeEach(async (to, from, next) => {
  try {
    const { data } = await axios.post(Vue.prototype.API_ENDPOINT + '/operator/checkLogin', {headers: { 'Content-Type': 'application/json', 'Content-Test-Type-XYZ': 'content-test-xyz' }})
    if (data.user === null) {
      if (to.path !== '/login') {
        next('/login')
        return
      }
      next()
    } else {
      window.sessionStorage.setItem('user', JSON.stringify(data.user))
      await getPrivilegeList(data.user.groupId)
      if (!to.meta.module || data.user.isSuperAdmin) {
        next()
        return
      }
      if (!Vue.prototype.PRIVILEGE.includes(to.meta.module)) {
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Does not have access')
        next('/dashboard')
        return
      }
      next()
    }
  } catch (err) {
    console.log('this is an error ', err)
  }
})

let getPrivilegeList = async function (groupId) {
  if (!Vue.prototype.PRIVILEGE) {
    const { data } = await axios.post(Vue.prototype.API_ENDPOINT + '/system/privilege', { groupId: groupId }, { headers: { 'Content-Type': 'application/json' } })
    Vue.prototype.PRIVILEGE = data.privilege
  }
}

axios.interceptors.request.use(function (config) {
  let method = config.method
  if (Vue.prototype.CURRENCY) {
    config.headers['ocms-currency'] = Vue.prototype.CURRENCY
  }
  if (method === 'post' || method === 'put' || method === 'delete') {
    let sessionUser = JSON.parse(window.sessionStorage.getItem('user'))
    if (sessionUser) {
      if (!(config.data instanceof FormData)) {
        config.data = {
          ...config.data,
          operator: sessionUser['username']
        }
      }
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response
}, function (error) {
  console.log(error)
  // Do something with response error
  if (error.response.status === 401 && window.location.hash !== '#/login') {
    window.location.href = '/'
  }
  return Promise.reject(error)
})

if (process.env.NODE_ENV === 'production') {
  axios.get('/getSiteConfig', {
    headers: { 'Content-Type': 'application/json' }
  }).then(({ data }) => {
    Vue.prototype.CURRENCY = data.CURRENCY
    Vue.prototype.SETTING = {
      product: data.PRODUCT,
      productLink: data.PRODUCTLINK,
      system: data.SYSTEM,
      logo: data.LOGO,
      timezone: data.TIMEZONE
    }
    initializeVue()
  }).catch(error => console.log(error))
} else {
  initializeVue()
}

function initializeVue () {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    template: '<App v-if="!fetching"/>',
    components: {
      App
    },
    data: {
      fetching: true
    },
    methods: {
      async checkLogin () {
        try {
          let { data } = await this.$http.post(Vue.prototype.API_ENDPOINT + '/operator/checkLogin', {headers: { 'Content-Type': 'application/json' }})
          return data
        } catch (err) {
          console.log(err)
          throw err
        }
      },
      async getSystemConfig () {
        try {
          let { data } = await this.$http.post(Vue.prototype.API_ENDPOINT + '/system/config', {
            param: [ 'tournament.config.main.time', 'tournament.config.quick.time' ]
          }, {
            headers: { 'Content-Type': 'application/json' }
          })
          let conf = {}
          if (data.config !== null && data.config.length > 0) {
            data.config.map(x => {
              conf[x.Parameter] = JSON.parse(x.Value)
              return x
            })
          }
          Vue.prototype.CONFIG = conf
        } catch (err) {
          console.log(err)
          throw err
        }
      },
      async getLanguageList () {
        try {
          let { data } = await this.$http.get(Vue.prototype.API_ENDPOINT + '/system/getLanguage', { headers: { 'Content-Type': 'application/json' } })
          let langId = {}
          let langList = data.language.map(x => {
            langId[x.Lang] = x.Lang
            return { Id: x.Id, Lang: x.Lang, Name: x.Name }
          })
          Vue.prototype.LANGID = langId
          Vue.prototype.LANG = langList
        } catch (err) {
          console.log(err)
          throw err
        }
      }
    },
    async created () {
      try {
        this.fetching = true
        await Promise.all([ this.getSystemConfig(), this.getLanguageList() ])
      } catch (err) {
        console.log(err)
      } finally {
        this.fetching = false
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/main.js